import { Title } from 'components/Toolbar/constants';
import { InlineStyle } from 'const';

export const ControlMap: Record<InlineStyle, string> = {
  [InlineStyle.BOLD]: Title.FONT_DECORATION_BOLD,
  [InlineStyle.ITALIC]: Title.FONT_DECORATION_ITALIC,
  [InlineStyle.UNDERLINE]: Title.FONT_DECORATION_UNDERLINE,
};
